import React, { useMemo, useState } from "react";




const baseInsights =
[
    {
        severity: "CRITICAL",
        title: "Transformer Oil Leak",
        building: "Broadcasting House",
        location: "Plant Room • Basement",
        image: "assetimages/transformer1.jpg"
    },
    {
        severity: "CRITICAL",
        title: "Transformer Overheating",
        building: "Broadcasting House",
        location: "Electrical Room",
        image: "assetimages/transformer2.jpg"
    },
    {
        severity: "MEDIUM",
        title: "Lighting Panel Inspection Due",
        building: "Media Village",
        location: "Level 01 • Corridor",
        image: "assetimages/lighting_panel.jpg"
    },
    {
        severity: "LOW",
        title: "Desk Damaged",
        building: "Pinkston",
        location: "Open Office",
        image: "assetimages/desk.jpg"
    },
    {
        severity: "MEDIUM",
        title: "Monitor Display Fault",
        building: "Holborn",
        location: "Meeting Room 2",
        image: "assetimages/monitor.png"
    },
    {
        severity: "CRITICAL",
        title: "Transformer Thermal Alarm",
        building: "Broadcasting House",
        location: "Switch Room",
        image: "assetimages/transformer3.jpg"
    },
    {
        severity: "LOW",
        title: "Robot Maintenance Required",
        building: "Innovation Lab",
        location: "Ground Floor",
        image: "assetimages/robot.jpg"
    }
];

const insights = [];

for (let loop = 0; loop < 3; loop++)
{
    baseInsights.forEach((item, index) =>
    {
        insights.push({
            ...item,
            id: (loop * baseInsights.length) + index + 1
        });
    });
}


function getSeverityStyle(
    severity)
{
    switch (severity)
    {
        case "CRITICAL":

            return {
                background:
                    "linear-gradient(180deg,#ef4444 0%,#b91c1c 100%)",

                boxShadow:
                    "0 5px 12px rgba(239,68,68,.28)"
            };

        case "MEDIUM":

            return {
                background:
                    "linear-gradient(180deg,#fbbf24 0%,#d97706 100%)",

                boxShadow:
                    "0 5px 12px rgba(245,158,11,.26)"
            };

        default:

            return {
                background:
                    "linear-gradient(180deg,#4ade80 0%,#16a34a 100%)",

                boxShadow:
                    "0 5px 12px rgba(34,197,94,.24)"
            };
    }
}


export default function WorkspaceInsightList(
{
    onInsightSelected
})
{
    const [search, setSearch] =
        useState("");

    const [selectedInsightId, setSelectedInsightId] =
        useState(null);


    const filteredInsights =
        useMemo(
            function ()
            {
                const value =
                    search
                        .trim()
                        .toLowerCase();

                if (!value)
                {
                    return insights;
                }

                return insights.filter(
                    function (insight)
                    {
                        return (
                            insight.title
                                .toLowerCase()
                                .includes(value)
                            ||
                            insight.building
                                .toLowerCase()
                                .includes(value)
                            ||
                            insight.location
                                .toLowerCase()
                                .includes(value)
                            ||
                            insight.severity
                                .toLowerCase()
                                .includes(value)
                        );
                    }
                );
            },
            [
                search
            ]
        );


    const selectInsight =
        function (
            insight)
        {
            setSelectedInsightId(
                insight.id);

            if (onInsightSelected)
            {
                onInsightSelected(
                    insight);
            }
        };


    return (

        <div
            style={{
                width: "100%",
                height: "100%",

                display: "flex",
                flexDirection: "column",

                minHeight: 0
            }}
        >

            {/*==================================================
                SEARCH
            ==================================================*/}

            <div
                style={{
                    padding:
                        "18px 18px 12px"
                }}
            >

                <input
                    type="text"

                    value={search}

                    placeholder=
                        "Search title, building or location..."

                    onChange={
                        function (event)
                        {
                            setSearch(
                                event.target.value);
                        }
                    }

                    style={{
                        boxSizing:
                            "border-box",

                        width:
                            "100%",

                        padding:
                            "12px 14px",

                        border:
                            "1px solid rgba(255,255,255,.09)",

                        borderRadius:
                            "11px",

                        outline:
                            "none",

                        background:
                            "rgba(255,255,255,.055)",

                        boxShadow:
                            "inset 0 1px 1px rgba(0,0,0,.18)",

                        color:
                            "#ffffff",

                        fontSize:
                            "13px"
                    }}
                />

            </div>


            {/*==================================================
                RESULT COUNT
            ==================================================*/}

            <div
                style={{
                    padding:
                        "0 20px 12px",

                    color:
                        "#94a3b8",

                    fontSize:
                        "11px",

                    fontWeight:
                        700,

                    letterSpacing:
                        ".75px",

                    textTransform:
                        "uppercase"
                }}
            >
                {
                    filteredInsights.length
                }
                {
                    filteredInsights.length === 1
                        ? " Result"
                        : " Results"
                }
            </div>


            {/*==================================================
                INSIGHT LIST
            ==================================================*/}

            <div
                style={{
                    flex:
                        1,

                    minHeight:
                        0,

                    overflowY:
                        "hidden",

                    overflowX:
                        "hidden",

                    padding:
                        "0 12px 20px"
                }}
            >

                {
                    filteredInsights.map(
                        function (
                            insight)
                        {
                            const selected =
                                selectedInsightId
                                === insight.id;

                            const severityStyle =
                                getSeverityStyle(
                                    insight.severity);

                            return (

                                <div
                                    key={insight.id}

                                    onClick={
                                        function ()
                                        {
                                            selectInsight(
                                                insight);
                                        }
                                    }

                                    style={{
                                        display:
                                            "flex",

                                        alignItems:
                                            "stretch",

                                        gap:
                                            "14px",

                                        marginBottom:
                                            "11px",

                                        padding:
                                            "11px",

                                        border:
                                            selected
                                                ? "1px solid rgba(90,155,214,.55)"
                                                : "1px solid rgba(255,255,255,.045)",

                                        borderRadius:
                                            "14px",

                                        background:
                                            selected
                                                ? "rgba(90,155,214,.17)"
                                                : "rgba(255,255,255,.04)",

                                        boxShadow:
                                            selected
                                                ? "0 12px 28px rgba(0,0,0,.30)"
                                                : "0 7px 18px rgba(0,0,0,.18)",

                                        cursor:
                                            "pointer",

                                        transform:
                                            "translateY(0)",

                                        transition:
                                            "background .2s ease, "
                                            + "border-color .2s ease, "
                                            + "box-shadow .2s ease, "
                                            + "transform .2s ease"
                                    }}

                                    onMouseEnter={
                                        function (
                                            event)
                                        {
                                            event
                                                .currentTarget
                                                .style
                                                .background =
                                                "rgba(90,155,214,.14)";

                                            event
                                                .currentTarget
                                                .style
                                                .transform =
                                                "translateY(-2px)";

                                            event
                                                .currentTarget
                                                .style
                                                .boxShadow =
                                                "0 13px 30px rgba(0,0,0,.30)";
                                        }
                                    }

                                    onMouseLeave={
                                        function (
                                            event)
                                        {
                                            event
                                                .currentTarget
                                                .style
                                                .background =
                                                selected
                                                    ? "rgba(90,155,214,.17)"
                                                    : "rgba(255,255,255,.04)";

                                            event
                                                .currentTarget
                                                .style
                                                .transform =
                                                "translateY(0)";

                                            event
                                                .currentTarget
                                                .style
                                                .boxShadow =
                                                selected
                                                    ? "0 12px 28px rgba(0,0,0,.30)"
                                                    : "0 7px 18px rgba(0,0,0,.18)";
                                        }
                                    }
                                >

                                    {/*==================================
                                        IMAGE
                                    ==================================*/}

                                    <div
                                        style={{
                                            width:
                                                "126px",

                                            minWidth:
                                                "126px",

                                            height:
                                                "88px",

                                            overflow:
                                                "hidden",

                                            borderRadius:
                                                "11px",

                                            background:
                                                "rgba(255,255,255,.05)",

                                            boxShadow:
                                                "0 6px 16px rgba(0,0,0,.24)"
                                        }}
                                    >

                                        <img
                                            src={
                                                insight.image
                                            }

                                            alt={
                                                insight.title
                                            }

                                            style={{
                                                width:
                                                    "100%",

                                                height:
                                                    "100%",

                                                display:
                                                    "block",

                                                objectFit:
                                                    "cover",

                                                transition:
                                                    "transform .3s ease"
                                            }}

                                            onMouseEnter={
                                                function (
                                                    event)
                                                {
                                                    event
                                                        .currentTarget
                                                        .style
                                                        .transform =
                                                        "scale(1.06)";
                                                }
                                            }

                                            onMouseLeave={
                                                function (
                                                    event)
                                                {
                                                    event
                                                        .currentTarget
                                                        .style
                                                        .transform =
                                                        "scale(1)";
                                                }
                                            }
                                        />

                                    </div>


                                    {/*==================================
                                        CONTENT
                                    ==================================*/}

                                    <div
                                        style={{
                                            flex:
                                                1,

                                            minWidth:
                                                0,

                                            display:
                                                "flex",

                                            flexDirection:
                                                "column",

                                            justifyContent:
                                                "center"
                                        }}
                                    >

                                        <div
                                            style={{
                                                marginBottom:
                                                    "7px",

                                                overflow:
                                                    "hidden",

                                                color:
                                                    "#ffffff",

                                                fontSize:
                                                    "14px",

                                                fontWeight:
                                                    650,

                                                lineHeight:
                                                    "1.3",

                                                textOverflow:
                                                    "ellipsis"
                                            }}
                                        >
                                            {
                                                insight.title
                                            }
                                        </div>


                                        <div
                                            style={{
                                                marginBottom:
                                                    "3px",

                                                color:
                                                    "#d1d5db",

                                                fontSize:
                                                    "12px",

                                                fontWeight:
                                                    500
                                            }}
                                        >
                                            {
                                                insight.building
                                            }
                                        </div>


                                        <div
                                            style={{
                                                marginBottom:
                                                    "9px",

                                                color:
                                                    "#7f8b9d",

                                                fontSize:
                                                    "11px",

                                                lineHeight:
                                                    "1.35"
                                            }}
                                        >
                                            {
                                                insight.location
                                            }
                                        </div>


                                        <div>

                                            <span
                                                style={{
                                                    display:
                                                        "inline-flex",

                                                    alignItems:
                                                        "center",

                                                    justifyContent:
                                                        "center",

                                                    minWidth:
                                                        "68px",

                                                    padding:
                                                        "4px 9px",

                                                    borderRadius:
                                                        "7px",

                                                    background:
                                                        severityStyle
                                                            .background,

                                                    boxShadow:
                                                        severityStyle
                                                            .boxShadow,

                                                    color:
                                                        "#ffffff",

                                                    fontSize:
                                                        "9px",

                                                    fontWeight:
                                                        800,

                                                    letterSpacing:
                                                        ".7px",

                                                    textTransform:
                                                        "uppercase"
                                                }}
                                            >
                                                {
                                                    insight.severity
                                                }
                                            </span>

                                        </div>

                                    </div>

                                </div>

                            );
                        }
                    )
                }


                {
                    filteredInsights.length === 0
                    &&
                    (
                        <div
                            style={{
                                padding:
                                    "50px 20px",

                                color:
                                    "#94a3b8",

                                fontSize:
                                    "13px",

                                lineHeight:
                                    "1.6",

                                textAlign:
                                    "center"
                            }}
                        >
                            No insights match your search.
                        </div>
                    )
                }

            </div>

        </div>

    );
}